var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"submit-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('handleSubmit')}}},[_vm._v("提交信息，去开店")])}
var staticRenderFns = []

export { render, staticRenderFns }